<template>
  <Layout>
    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-12">
        API Consumer Übersicht
      </label>
    </div>
    <b-row>
      <div class="col-lg-12" v-if="allApiConsumers.length > 0">
        <b-table
          ref="tenantsTable"
          hover
          :items="allApiConsumers"
          :fields="fields"
          bordered
          striped
        >
        <template #cell(actions)="apiConsumer">
          <ul class="list-inline font-size-20 contact-links mb-0">
            <li class="list-inline-item px-2">
              <a
              v-b-tooltip.hover
              :title= "$t('admin.tenant.edit-icon')"
              @click="showConsumer(apiConsumer.item.id)"
              class="tenant--function tenant--function__modify-tenant"
              >
                <i class="bx bx-pencil" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </template>
        </b-table>
      </div>
    </b-row>
    <b-row>
      <div class="col-lg-12">
        <router-link tag="a" to="api-consumer/create">
          <button class="btn btn-primary m-3" type="button">
            Erstellen
          </button>
        </router-link>
      </div>
    </b-row>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/admin";
import { adminService } from "@/helpers/services/admin/adminService";
import router from '@/router';
import i18n from "@/i18n";


export default {
  name: "ApiConsumerList",
  components: { Layout },
  data() {
    return {
      allApiConsumers: [],
      fields: [
        { key: "name", label: "Name" },
        { key: "actions", label: i18n.t("actions") }
      ],
    }
  },
  methods: {
    showConsumer(apiConsumerId) {
      router.push("api-consumer/" + apiConsumerId);
    },
  },
  created() {
    adminService.fetchApiConsumers()
      .then(t => this.allApiConsumers = t);
  },
}
</script>

<style>

</style>